// components/common/SessionManager.jsx

import useSessionTimeout from "utils/hooks/useSessionTimeout";

const SessionManager = () => {
  useSessionTimeout();
  return null;
};

export default SessionManager;
